import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  Modal,
  useTheme,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const CopyCollectionModal = ({
  copyPopup,
  setCopyPopup,
  handlePublicCollectionCopy,
}) => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const navbarBackground = theme.palette?.navbar?.main;
  const { user } = useSelector((state) => state.auth);
  const { id } = useParams();

  const handleCopy = async () => {
    setLoading(true);
    try {
      await handlePublicCollectionCopy(user, id);
    } catch (error) {
      toast.error("Failed to copy collection");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setCopyPopup(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100vw", sm: "50vw", md: "35vw" },
    bgcolor: "background.paper",
    boxShadow: 0,
    borderRadius: 2,
  };

  return (
    <Modal
      open={copyPopup}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            Copy Public Collection
          </Typography>
          <AccessibleIconButton
            title="Close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </AccessibleIconButton>
          <Typography sx={{ mt: 2 }}>
            Would you like to copy this public collection to your private
            collection?
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: navbarBackground,
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={loading}
            sx={{ width: "45%", textTransform: "none", borderColor: "#406da4" }}
          >
            <Typography variant="h6" sx={{ color: "#406da4" }}>
              Cancel
            </Typography>
          </Button>
          <Button
            onClick={handleCopy}
            disabled={loading}
            sx={{
              width: "45%",
              textTransform: "none",
              backgroundColor: "#406da4",
              display: "flex",
              gap: 1,
            }}
          >
            {loading && <CircularProgress size={20} />}
            <Typography variant="h6">Copy</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CopyCollectionModal;
